import React, { Component, Fragment } from 'react';

const Dashboard = () => {
    return (
        <div>Dashboard</div>
    )
}

export default Dashboard
